import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, ChevronDownIcon, LogInIcon, MenuIcon, XIcon } from 'lucide-react';
import { brand, nav } from '../data/content';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-200 ease-out ${scrolled || open ? 'border-b border-line bg-ink/90 backdrop-blur' : 'border-b border-transparent bg-transparent'}`} data-id="element-101" data-mp="1kxh5gj8z1clt">
      <div className="mx-auto flex h-16 max-w-shell items-center justify-between px-5 lg:px-8" data-id="element-102" data-mp="1yrhuume19n9i">
        <a href="#top" className="display text-xl tracking-tight text-cream md:text-2xl" data-id="element-103" data-mp="23q1jwvnxbf63">
          {brand.nameStrong}
          <span className="text-brand-red" data-id="element-104" data-mp="1y79rvoaxwwnu">{brand.nameAccent}</span>
        </a>

        <nav aria-label="Main" className="hidden items-center gap-8 md:flex" data-id="element-105" data-mp="1u3k594dtsp5g">
          {nav.map((item, i) => <a key={item.label} href={item.href} className="flex items-center gap-1 text-sm font-medium text-cream/80 transition-colors duration-150 ease-out hover:text-cream" data-id="element-106" data-mp="1p5im6jgegptz" data-mpi={i}>
              {item.label}
              {i === 0 && <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="2cvw5nlkx5gcy" />}
            </a>)}
        </nav>

        <div className="hidden items-center gap-5 md:flex" data-id="element-108" data-mp="282thjsywuz45">
          <a href="#top" className="flex items-center gap-2 text-sm font-medium text-cream/80 transition-colors duration-150 ease-out hover:text-cream" data-id="element-109" data-mp="235jmnxsr5v8x">
            <LogInIcon className="h-4 w-4" aria-hidden="true" data-id="element-110" data-mp="2vtyyycki1zgk" />
            Log in
          </a>
          <a href="#pricing" className="group inline-flex items-center gap-2 rounded-md bg-brand-red px-4 py-2 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-redDark" data-id="element-111" data-mp="tw5bwqm3b5hm">
            Buy Now
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-112" data-mp="k63lhs69lazj" />
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-md p-2 text-cream transition-colors duration-150 ease-out hover:bg-white/5 md:hidden" data-id="element-113" data-mp="aaaa4c4a7njc">
          {open ? <XIcon className="h-5 w-5" data-id="element-114" data-mp="68fb5e9tpm8q" /> : <MenuIcon className="h-5 w-5" data-id="element-115" data-mp="1vkz9w5upqqta" />}
        </button>
      </div>

      {open && <div className="border-t border-line bg-ink px-5 pb-6 pt-4 md:hidden" data-id="element-116" data-mp="20kbvyodrftut">
          <nav aria-label="Mobile" className="flex flex-col gap-4" data-id="element-117" data-mp="20i95k38p3ypk">
            {nav.map(item => <a key={item.label} href={item.href} onClick={() => setOpen(false)} className="text-base font-medium text-cream/85" data-id="element-118" data-mp="2am667nnwt5j1">
                {item.label}
              </a>)}
            <a href="#top" onClick={() => setOpen(false)} className="text-base font-medium text-cream/85" data-id="element-119" data-mp="2eoucpop5i0cu">
              Log in
            </a>
            <a href="#pricing" onClick={() => setOpen(false)} className="mt-1 inline-flex w-fit items-center gap-2 rounded-md bg-brand-red px-4 py-2 text-sm font-semibold text-white" data-id="element-120" data-mp="2og730bvawigr">
              Buy Now
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-121" data-mp="2yewffp4fhapm" />
            </a>
          </nav>
        </div>}
    </header>;
}